/**
 * Fraction of market value paid out per payout kind. The server recomputes
 * payouts authoritatively on submit; the client uses these for its preview.
 */
export const TRADE_PAYOUT_MULTIPLIERS = {
    cash: 0.7,
    store_credit: 0.8,
};
/**
 * Catalog language axis accepted by the PkmnPrices proxy. Distinct from
 * `CARD_LANGUAGES`, which is the language printed on a physical card.
 */
export const CATALOG_LANGUAGE_OPTIONS = [
    { value: 'english', label: 'English' },
    { value: 'japanese', label: 'Japanese (Pro tier)' },
];
//# sourceMappingURL=dto.js.map